"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relationshipArray = void 0;
exports.relationshipArray = [
    "Padre",
    "Madre",
    "Hijo/a",
    "Hermano/a",
    "Cónyuge",
    "Pareja",
    "Sobrino/a",
    "Abuelo/a",
    "Nieto/a",
    "Otro",
];
